// Import SCSS
import '../css/theme.scss';

// Dependencies
import { debounce } from 'lodash-es';
import Cookies from 'js-cookie';

// Note: Feature modules (projects-swiper, our-work, etc.) are loaded via
// separate script tags in Liquid templates. They self-initialize when loaded.
// This keeps the main bundle small and allows conditional loading per page.

// Initial console log to verify script is loading
console.log("=== THEME.JS LOADED ===", new Date().toISOString());
console.log("theme.js loaded", document.querySelectorAll('[data-expand-btn]'));
Array.from(document.querySelectorAll('[data-expand-btn]')).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        let target;
        if (!btn.dataset.expandBtn) {
            target = [btn.nextElementSibling];
        } else {
            try {
                let scope = btn.closest('section, nav');
                if (!scope) scope = document;
                target = scope.querySelectorAll(btn.dataset.expandBtn);
            } catch (e) {
                console.error("Error when finding expand target", `selector: ${btn.dataset.expandBtn}`, e,)
            }
        }
        try {
            console.log("target", target)
            let added = false;
            target.forEach(function (el) {
                added = el.classList.toggle('expanded') || added;
            });
            return btn.classList.toggle('active', added);
        } catch (e) {
            if (target) {
                console.error("Error when expanding accordion", e, btn.nextElementSibling)
            }
        }
        btn.classList.toggle('active');
    });
});

let instagramSection = document.querySelector('[data-instagram-feed]');
if (instagramSection) {
    function render(data) {
        const template = instagramSection.querySelector('[data-template-image]');
        const containers = instagramSection.querySelectorAll('[data-instagram-container]');
        data.forEach((item, index) => {
            const targetRow = containers[index % containers.length];
            const newElement = template.children[0].cloneNode(true);
            const imageEl = newElement.querySelector('img');

            newElement.removeAttribute('data-template-image');
            newElement.href = item.permalink;
            if (item.media_type == "VIDEO" && item.thumbnail_url) {
                imageEl.src = item.thumbnail_url;
            } else {
                imageEl.src = item.media_url;
            }
            imageEl.alt = item.caption;
            targetRow.appendChild(newElement);
        });
        setTimeout(()=> document.dispatchEvent(new Event('instagram-loaded')));
        
    }
    async function instagramInit() {
        const token = instagramSection.dataset.instagramFeed;
        const response = await fetch(`https://graph.instagram.com/me/media?access_token=${token}&fields=media_url,media_type,caption,permalink,thumbnail_url`);
        const data = (await response.json()).data;
        console.log("instagram data", data);

        render(data);
        
    }
    instagramInit();
}

function initContactModal() {
    // data-contact-modal-trigger
    const modal = document.querySelector('[data-contact-modal]');
    const buttons = Array.from(document.querySelectorAll('[data-contact-modal-trigger]'));
    buttons.forEach((btn) => {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            modal.classList.add('active');
        });
    });
    Array.from(document.querySelectorAll('[data-contact-modal-close]')).forEach(function(el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            modal.classList.remove('active');
        });
    })

}
function initCookieModal() {

    const cookieConsent = Cookies.get('cookie-box');

    if(!cookieConsent) {
        //data-cookie-modal-wrapper
        const wrapper = document.querySelector('[data-cookie-modal-wrapper]');
        if (!wrapper) return console.warn("No cookie modal wrapper found");
        const button = document.querySelector('[data-cookie-accept]');
        if (!button) return console.error("No cookie accept button found");

        button.addEventListener('click', function (e) {
            e.preventDefault();
            Cookies.set('cookie-box', 'true', { expires: 365 });
            wrapper.classList.remove('active');
            // document.body.classList.remove('scroll-lock');
        });

        setTimeout(() => {
            wrapper.classList.add('active')
            // document.body.classList.add('scroll-lock');
        }, 500)
    }

}



// Feature modules (our-work, projects-swiper, etc.) are now loaded via
// separate script tags in Liquid and self-initialize. See vite.config.js
// for entry points and theme.liquid / section files for conditional loading.

// Generic scroll-reveal: adds `is-visible` to any [data-reveal] element as it
// enters the viewport, staggering siblings within the same [data-reveal-group]
// (or parent) via a CSS transition-delay based on their order.
function initScrollReveal() {
    const items = Array.from(document.querySelectorAll('[data-reveal]'));
    if (!items.length) return;

    const groups = new Map();
    items.forEach((el) => {
        const group = el.closest('[data-reveal-group]') || el.parentElement;
        if (!groups.has(group)) groups.set(group, []);
        groups.get(group).push(el);
    });
    groups.forEach((groupItems) => {
        groupItems.forEach((el, index) => {
            el.style.setProperty('--reveal-delay', `${index * 80}ms`);
        });
    });

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                obs.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

    items.forEach((el) => observer.observe(el));
}

// Always initialize modals
initContactModal();
initCookieModal();
initScrollReveal();
